module.exports = __webpack_public_path__ + "static/media/icon-eureka-blue.8e719ec5.svg";